module.exports = __webpack_public_path__ + "static/media/tier-3.46da20fe.jpg";